import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-opt-v5',
    templateUrl: './opt-v5.component.html',
    styleUrls: ['./opt-v5.component.css']
})
export class OptV5Component implements OnInit {
    @Input('paramFormOptV5') paramFormOptV5: FormGroup;
    @Input('readOnly') readOnly: boolean;
    @Input('typesOptV5') typesOptV5: any [] = [];

    constructor() {
    }

    ngOnInit() {
    }

}
